import type { DamageType } from "@engine/types/combat.js";

/**
 * Element-coded damage feedback colors (EOB2-style splats).
 *
 * `splat` fills the splash blob behind the floating number; `text` is
 * the number itself (kept pale so it reads over the splat at small
 * sizes). Physical damage is classic blood; every other type keys to
 * its element so a fire hit *reads* as fire before the log line does.
 */
export const DAMAGE_COLORS: Record<DamageType, { splat: string; text: string }> = {
  slashing: { splat: "#a01818", text: "#ffe2e2" },
  piercing: { splat: "#a01818", text: "#ffe2e2" },
  bludgeoning: { splat: "#8c2424", text: "#ffe2e2" },
  fire: { splat: "#d2660f", text: "#fff0cf" },
  cold: { splat: "#2b7fb4", text: "#e8f8ff" },
  lightning: { splat: "#c8b117", text: "#fffce0" },
  poison: { splat: "#3a8f2b", text: "#e4ffdd" },
  acid: { splat: "#6f9c14", text: "#f6ffdb" },
  necrotic: { splat: "#4a3266", text: "#ece0fa" },
  radiant: { splat: "#c09a20", text: "#fffbe6" },
  psychic: { splat: "#8f2fa3", text: "#f9e4ff" },
  force: { splat: "#3350a8", text: "#e4ebff" },
  thunder: { splat: "#5a6f83", text: "#eef4fa" },
};

export function damageColor(type: string): { splat: string; text: string } {
  return DAMAGE_COLORS[type as DamageType] ?? DAMAGE_COLORS.bludgeoning;
}

/**
 * GF7 — restorative green for heal popups (`combat:healed`). Rendered
 * as a soft petal burst with a "+" prefix so it can never be mistaken
 * for a hit even at a glance.
 */
export const HEAL_COLOR = { splat: "#2e8b3a", text: "#eefbe9" } as const;
